import { useSelector } from 'react-redux';
import { isEmpty } from 'validate.js';

import { PUPPY_ID } from 'dpl/constants/query_params';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import { puppyDataQueryDefinition } from '../utils/queryDefinitions';

export function usePuppyData() {
  const puppyId = useSelector(
    ({ server, queryParams }) => server.puppyId || queryParams[PUPPY_ID]
  );

  const { value: puppyData, isFetching } = useResourceQuery({
    ...puppyDataQueryDefinition(puppyId),
    enabled: Boolean(puppyId)
  });

  const {
    meta,
    puppy,
    litter,
    breeder,
    transportation,
    included_with_puppy: includedWithPuppy,
    owner_stories: ownerStories
  } = puppyData;

  const isValid =
    !isEmpty(meta) ||
    !isEmpty(puppy) ||
    !isEmpty(litter) ||
    !isEmpty(breeder) ||
    !isEmpty(transportation);

  return {
    isValid,
    isFetching,
    meta,
    puppy,
    litter,
    breeder,
    transportation,
    includedWithPuppy,
    ownerStories
  };
}
